import { IDeleteEntregaObrasClienteArquivoUseCase } from "../../../presentation/useCases/delete/delete_entrega_obras_cliente_arquivo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaObrasClienteArquivoUseCase
 */

export class DeleteEntregaObrasClienteArquivoUseCase implements IDeleteEntregaObrasClienteArquivoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObrasClienteArquivo: number): Promise<void> {
    await this.repository.deleteEntregaObrasClienteArquivos(idEntregaObrasClienteArquivo);

  }
}
